import { StatusMessageBlacklisted } from '~/types/apiError'
import { AbortNavigationMessage } from '~/types/error'

export default defineNuxtPlugin(() => {
  const baseUrl = useRuntimeConfig().public.baseUrl

  let refreshingJwt: Promise<void> | null = null
  const abortController = new AbortController()

  const api = $fetch.create({
    baseURL: baseUrl,

    onRequest(context) {
      context.options.signal = abortController.signal

      const storeStore = useStoreStore(useNuxtApp().$pinia)
      if (storeStore.langCode && storeStore.isCurrentLangActive) {
        const endpoint = String(context.request)
        const localeParameter = `locale=${storeStore.langCode}`
        // could bee already added in case of query retry
        if (!endpoint.includes(localeParameter)) {
          const paramChar = endpoint.includes('?') ? '&' : '?'
          context.request += `${paramChar}${localeParameter}`
        }
      }

      const optionsHeaders = new Headers(context.options.headers)
      context.options.headers = optionsHeaders || {}

      const token = useStoreAuth(useNuxtApp().$pinia).getJwtToken()

      if (token) context.options.headers.set('Loy-Authorization', `Bearer ${token}`)
    },

    retry: 1,
    retryStatusCodes: [401, 403],

    async onResponseError({ request, response }) {
      const { $pinia } = useNuxtApp()
      if ([401, 403].includes(response.status) && ['Invalid token', 'Token expired'].includes(response._data.detail)) {
        const { companyId, customerId } = useStoreApp($pinia)

        if (!refreshingJwt) {
          refreshingJwt = useStoreAuth($pinia)
            .refreshToken(companyId, customerId)
            .finally(() => (refreshingJwt = null))
        }

        await refreshingJwt
      } else if (response._data.code === StatusMessageBlacklisted) {
        abortController.abort()
        const statusMessage = useStoreApp($pinia).isAccountContext ? AbortNavigationMessage : StatusMessageBlacklisted
        showError({ statusCode: 403, statusMessage })
      } else if (response.status >= 500) {
        abortController.abort()
        showError({ statusCode: response.status })
      } else if ([401, 403].includes(response.status) || request.toString().includes('/jwt')) {
        const { companyId } = useStoreApp($pinia)

        if (!refreshingJwt) {
          refreshingJwt = useStoreAuth($pinia)
            .refreshToken(companyId)
            .finally(() => (refreshingJwt = null))
        }

        await refreshingJwt
      }
    }
  })
  return {
    provide: {
      api
    }
  }
})
